import React from 'react'

/**
 * HeaderContext
 * {
 *  type: PropTypes.oneOf([SLIM, CENTER, NAVBAR]).isRequired
 * }
 */

export default React.createContext({})

export const SLIM = 'slim'
export const CENTER = 'center'
export const NAVBAR = 'navbar'
